export default __webpack_public_path__ + "static/media/f978e2a9dc078908bf75b190a5c0fa62.svg";